import React  from "react";
import Home from "./pages/Home";
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import CruiseDeals from "./pages/CruiseDeals";
import Contact from "./pages/Contact";
import About from "./pages/About";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Singapore from "./pages/SingaporeCruise";
import Privacy from "./pages/Privacy";
// import LandCruise from "./pages/Land+Cruise";
import Blog from "./pages/Blog";
import Blog1 from "./Blogs/Blog1";
import Blog2 from "./Blogs/Blog2";
import Blog3 from "./Blogs/Blog3";
import Blog4 from "./Blogs/Blog4";
import CruiseBooking from "./components/CruiseBooking";
import CruiseBooking2 from "./components/CruiseBooking2";
import Blog5 from "./Blogs/Blog5";


function App() {


  return (

    <>

    <Router>
      <Routes> 
        <Route path="/" element={<Home />} />
        <Route path="/cruisedeals"element={<CruiseDeals/>}/>
        <Route path="/contact" element={<Contact/>} />
        <Route path="/about" element={<About />} />
        <Route path="/singapore-cruise" element={<Singapore/>} />
        <Route path="/privacy-policy" element={<Privacy/>} />
        {/* <Route path="/land+cruise" element={<LandCruise/>} /> */}
        <Route path="/blog" element={<Blog/>} />
        <Route path="/six-ways-to-find-the-cheapest-cruise-deals" element={<Blog1/>} />
        <Route path="/5-things-first-time-cruisers-must-know-before-booking-their-cruise-holiday" element={<Blog2/>} />
        <Route path="/top-4-european-summer-cruises-coming-in-2025" element={<Blog3/>} />
        <Route path="/top-5-northern-europe-cruises-in-2025" element={<Blog4/>} />
        <Route path="/int2special-3night-singapore" element={<CruiseBooking />} />
        <Route path="/int2special-4night-singapore" element={<CruiseBooking2 />} />
        <Route path="/5-Truths-you-didn’t-know-about-cruising" element={<Blog5 />} />
        
      </Routes>
    </Router>

    </>
  );
}

export default App;
